export const MAX_GAS_FAST = 1500;
